import * as React from 'react';
import Field from '../Field/Field';
import { BaseButton } from '../../BaseComponents';
import { Form } from 'react-final-form';
import { useTheme } from '../../theme';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../context';
import { getCheckInUrl } from '../../utils';
import { useRetrieveBookingValidation } from '../../RetrieveBooking/hooks';

const Checkin: React.FC = props => {
	const theme = useTheme('Forms').Booking;

	const { t } = useTranslation('Forms');
	const {
		Engine: { checkInURL },
		global: { reserveEngines }
	} = useConfig();

	const { ticketNumberValidation, lastNameValidation, requiredValidationWrapper } = useRetrieveBookingValidation();

	const onSubmit = (values: any) => {
		const ticket: string = values['ticket'];
		const lastName: string = values['lastName'];

		window.open(getCheckInUrl(checkInURL, '', ticket, lastName, reserveEngines));
	};

	return (
		<Form
			onSubmit={onSubmit}
			validateOnBlur={true}
			initialValues={{
				ticket: '',
				lastName: ''
			}}
		>
			{({ handleSubmit }) => (
				<div className={theme.container}>
					<form onSubmit={handleSubmit} className={theme.inner}>
						<Field
							name="ticket"
							label={t('Ticket number')}
							validation={requiredValidationWrapper(ticketNumberValidation)}
						/>

						<Field
							name="lastName"
							label={t('Last name')}
							validation={requiredValidationWrapper(lastNameValidation)}
						/>

						<BaseButton type="submit" variant="smallPrimary" size="large" className={theme.submit}>
							{t('Continue')}
						</BaseButton>
					</form>
				</div>
			)}
		</Form>
	);
};

export default Checkin;
